import React, { useCallback, useMemo } from "react";
import { Dropdown, Option } from "@fluentui/react-components";
import { observer } from "mobx-react";
import { useStyles } from "./AppMenuSetting.styles";
import { useRootStore } from "Store/RootStore";
import { useEnvironment, useFlighting } from "Shared/Hooks";
import { OptionOnSelectData, SelectionEvents } from "Shared/FluentUIUnstableDef";

const sovereignOptions = [
    { key: "off", label: "Off", envValue: undefined },
    { key: "bleu", label: "Bleu", envValue: "bleu" },
    { key: "delos", label: "Delos", envValue: "delos" }
];

const AppMenuSovSimulationToggleBase = () => {
    const settingStore = useRootStore("AppSettingStore");
    const { isSovereignBleu, isSovereignDelos } = useEnvironment();
    const flighting = useFlighting(["m365pulse-partner-testing"]);
    const classNames = useStyles();

    const selectedKey = useMemo(() => {
        if (isSovereignBleu) {
            return "bleu";
        }
        if (isSovereignDelos) {
            return "delos";
        }
        return "off";
    }, [isSovereignBleu, isSovereignDelos]);

    const selectedLabel = sovereignOptions.find((opt) => opt.key === selectedKey)?.label ?? "Off";

    const onSelectEnvironment = useCallback(
        (_event: SelectionEvents, data: OptionOnSelectData) => {
            const selected = sovereignOptions.find((opt) => opt.key === data.optionValue);
            settingStore.settings.NODE_ENV = selected?.envValue ?? process.env.NODE_ENV;
        },
        [settingStore]
    );

    return (
        flighting && (
            <div className={classNames.container}>
                <div className={classNames.text}>Simulate sovereign environment</div>
                <div className={classNames.dropdownContainer}>
                    <Dropdown
                        className={classNames.dropdown}
                        onOptionSelect={onSelectEnvironment}
                        value={selectedLabel}
                        selectedOptions={[selectedKey]}
                        aria-label="Simulate sovereign environment"
                    >
                        {sovereignOptions.map((opt) => (
                            <Option key={opt.key} value={opt.key} text={opt.label}>
                                {opt.label}
                            </Option>
                        ))}
                    </Dropdown>
                </div>
            </div>
        )
    );
};

export const AppMenuSovSimulationToggle = observer(AppMenuSovSimulationToggleBase);
